var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.415 9.428a.64.64 0 0 0-.918-.04.674.674 0 0 0-.04.936 4.856 4.856 0 0 1 1.24 3.25v2.851a.243.243 0 0 1-.239.243H4.535a.243.243 0 0 1-.239-.243v-2.851c0-2.649 2.11-4.799 4.699-4.799 2.369 0 4.297-1.97 4.297-4.39C13.292 1.967 11.367 0 8.998 0 6.63 0 4.701 1.97 4.701 4.39c0 .722.177 1.442.51 2.076.169.325.562.443.88.27a.67.67 0 0 0 .264-.9A3.13 3.13 0 0 1 6 4.388C6 2.7 7.344 1.328 8.998 1.328s2.997 1.372 2.997 3.061c0 1.69-1.343 3.062-2.997 3.062C5.69 7.45 3 10.199 3 13.577v2.852C3 17.295 3.69 18 4.538 18h8.924C14.31 18 15 17.295 15 16.429v-2.852a6.188 6.188 0 0 0-1.585-4.15z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.3fdb6cb55f63cc586abf34b3e8753a12.svg";
export { ForwardRef as ReactComponent };